import React from "react";
import "./App.css";
import Experience from "./Experience";

function App() {
  return (
    <div className="App">
      <Experience />
    </div>
  );
}

export default App;
